import { render, staticRenderFns } from "./LinkDescription.vue?vue&type=template&id=3f58f910&"
import script from "./LinkDescription.vue?vue&type=script&lang=ts&"
export * from "./LinkDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports